import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Alert } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from './LoadingComponent';
import { connect } from 'react-redux';
import { RenderVirtualTable } from './TableComponent';
import { ScatterPlot } from './PlotComponent';
import { pick } from './Functions';
import { CSVLink } from "react-csv";
import { postRequest } from '../redux/ActionCreators';

// import 'rsuite/dist/styles/rsuite-default.css';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    suit_params: state.suit_params
  };
};

class SuitabilityReport extends Component {
    constructor(props){
        super(props);
        this.state = {
            msg:null,
            loading_table:false,
            loading_score:false
        };
        this.loadTable = this.loadTable.bind(this);
    }
    // }

    async loadTable(){
      try {
        this.setState({
          loading_table:true
        });
        const summ_table = await postRequest({
          bucket:'condor-sura-wm', 
          key:"suitability/output/analysis/pe/client_summary.csv", //"suitability/input/static/pe/matricesRiesgoPE.csv", 
          sep:',',
        }, 'retrieve_data_s3');
        
        await this.props.changeModel('suit_params.client_summ', summ_table);
        this.setState({
          loading_table:false,
          msg:summ_table.msg ? "Tabla de resumen no disponible" : "Tabla de resumen cargada"
        });
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          loading_table:false,
          msg: error.message
        });
      }
      try {
        this.setState({
          loading_score:true
        });
        const suit_table = await postRequest({
          bucket:'condor-sura-wm', 
          key:"suitability/output/analysis/pe/client_suit_summary.csv", //"suitability/input/static/pe/matricesRiesgoPE.csv", 
          sep:',',
        }, 'retrieve_data_s3');

        await this.props.changeModel('suit_params.client_suit_summ', suit_table);
        this.setState({
          loading_score:false,
          msg:suit_table.msg ? "No hay datos de score disponibles" : "Score cargados"
        });
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          loading_score:false,
          msg: error.message
        });
      }
    }

    render(){
      
        const suit_score = this.props.suit_params.client_suit_summ==null || this.props.suit_params.client_suit_summ?.msg ? null : this.props.suit_params.client_suit_summ.filter(k=>k['Score Posiciones']!=="" && k['Score Recomendación']!=="").map(k=>pick(k, ["Id Cliente", 'Score Posiciones', 'Score Recomendación']));
        return(
            <div className="container">
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                      <BreadcrumbItem><Link to='/suitability'>Proceso</Link></BreadcrumbItem>
                      <BreadcrumbItem active>Reporte</BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-12 col-md-9">
                      <div className="row justify-content-center" id="init">
                          <div className="col-12 mt-4">
                              <h5><center>Reporte de Suitability</center></h5>
                          </div>
                      </div>
                      <div className="row justify-content-center mt-5">
                        {this.state.loading_table ?
                          <div className="col-3">
                            <Loading />
                          </div>
                          :
                          <div className='col-auto'>
                              <Button 
                                  className="btn-corp"
                                  onClick={this.loadTable}>
                                  Ver Resumen
                              </Button>
                          </div>
                        }
                      </div>
                      {this.state.msg!=='' && this.state.msg!==null ?
                        <div className="row mt-4 justify-content-center">
                          <div className="col-6 m-3">
                            <Alert
                              color={this.state.msg.includes('Error') ? 'danger':'secondary'}
                              isOpen={this.state.msg!=='' && this.state.msg!==null} 
                              toggle={()=>this.setState({msg:null})}>
                                {this.state.msg}
                            </Alert>
                          </div>
                        </div>
                        :<></>
                      }
                      
                      {this.props.suit_params?.client_summ && this.props.suit_params?.client_summ.length>0 ?
                      <>
                        <div className="row m-4 justify-content-center">
                          <div className='col'>
                            <hr></hr>
                          </div>
                        </div>
                        <div className="row m-4 justify-content-center" id="summ">
                          <div className='col'>
                            <h6>Resumen General</h6>
                            <a className='linkcol' href='#scores'>scores&darr;</a>
                          </div>
                        </div>
                        <div className="row mt-4 justify-content-center">
                          <div className={"col-5"}>
                            <RenderVirtualTable 
                              data={this.props.suit_params.client_summ}
                              cell_width={['200px', '100px']}
                              fontsize={13}
                            />
                          </div>
                        </div>
                        <div className="row m-4 justify-content-center">
                          <div className='col-auto'>
                            <CSVLink className='link-btn' data={this.props.suit_params.client_summ} filename="tabla"><small>Descargar resumen&darr;</small></CSVLink>
                          </div>
                        </div>
                      </>
                      :null
                      }
                      {this.state.loading_score ?
                      <>
                        <div className="row m-4 justify-content-center">
                          <div className='col'>
                            <hr></hr>
                          </div>
                        </div>
                        <div className="row m-4 justify-content-center" id="scores">
                          <div className='col'>
                            <h6>Scores</h6>
                            <a className='linkcol' href='#summ'>summ&uarr;</a>
                          </div>
                        </div>
                        <div className="row m-4 justify-content-center" id="params">
                          <div className='col-3'>
                            <Loading/>
                          </div>
                        </div>
                      </>
                      :this.props.suit_params?.client_suit_summ && this.props.suit_params?.client_suit_summ.length>0 ?
                      <>
                        <div className="row m-4 justify-content-center">
                          <div className='col'>
                            <hr></hr>
                          </div>
                        </div>
                        <div className="row m-4 justify-content-center" id="params">
                          <div className='col'>
                            <h6>Scores</h6>
                            <a className='linkcol' href='#summ'>resumen&uarr;</a>
                          </div>
                        </div>
                        <div className="row m-4 justify-content-center">
                          <div className='col-md-6'>
                            <ScatterPlot
                              data={suit_score}
                              color="#000000"
                              xlabel="Score Posiciones"
                              ylabel="Score Recomendación"
                              xAxisId="Score Posiciones"
                              yAxisId="Score Recomendación"
                              zAxisId='Id Cliente'
                              dataName='Clientes'
                              width={400}
                              height={400}
                              ml={10}
                              legend={false}
                              percTooltip={false}
                              xpercAxis={false}
                              ypercAxis={false}
                            />
                          </div>
                        </div>
                        <div className="row m-4 justify-content-center">
                          <div className='col-auto'>
                            <CSVLink className='link-btn' data={this.props.suit_params.client_suit_summ} filename="tabla"><small>Descargar alertas&darr;</small></CSVLink>
                          </div>
                        </div>
                      </>
                      :null
                      }
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps)(SuitabilityReport));
